export const bhFlag = () => {
    return (

        <svg width={"100%"} height={"100%"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 900"><path d="M0 0h1500v900H0" fill="#fff" /><path d="M1500 0H375l225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90h1125" fill="#ce1126" /></svg>
    );
};